import React, { memo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import siteLogo from "../assets/images/logo.png";

import HeaderUserDropDown from "../components/HeaderUserDropDown";
import HeaderNavigation from "../components/HeaderNavigation";
import SideMenu from "../components/SideMenu";
import HeaderSearch from "../components/HeaderSearch";
import { getHomePageCategories ,getSettings,getHeaderMenu} from "../services/HomePageService";
import { getUserSession } from "../auth";
import HeaderFavCountIcon from "../components/HeaderFavCountIcon";

const CheckoutHeader = () => {
  useEffect(() => {
    getCats();
    getMenu();
    getSettingsData();
  }, []);

  const [categories, setCategories] = useState({ loader: true, data: [] });
  const [menu, setMenu] = useState({ loader: true, data: [] });
  const [settings, setSettings] = useState({ loader: true, data: [] });

  const getCats = async () => {
    const catData = await getHomePageCategories();
    if (catData) {
      setCategories({
        loader: false,
        data: catData,
      });
    }
  };

  const getMenu = async () => {
    const catData = await getHeaderMenu();
    if (catData) {
      setMenu({
        loader: false,
        data: catData,
      });
    }
  };
  const getSettingsData = async () => {
    const settData = await getSettings();
    if (settData) {
      setSettings({
        loader: false,
        data: settData,
      });
    }
  };

  const userSession = getUserSession();
  return (
    <>
      <header className='header clearfix'>
        <div className='top-header-group'>
          <div className='top-header'>
            <div className='res_main_logo'>
              <a href='/'>
                <img src={siteLogo} alt='logo' />
              </a>
            </div>
            <div className='main_logo' id='logo'>
              <a href='/'>
                <img src={siteLogo} alt='logo' />
              </a>
              <a href='/'>
                <img className='logo-inverse' src={siteLogo} alt='logo' />
              </a>
            </div>
            <HeaderSearch className='d-none d-sm-block search120' />

            <div className='header_right'>
              <ul>
                <li>
                  <a href={'tel:'+settings.data.phone_number} className='offer-link'>
                    <i className='uil uil-phone-alt'></i>{settings.data.phone_number}
                  </a>
                </li>

                <HeaderFavCountIcon />
                <HeaderUserDropDown
                  isLoggedIn={
                    userSession && userSession.authToken ? true : false
                  }
                  userName={(userSession && userSession.full_name) || ""}
                  isGuest={
                    (userSession && userSession.userType) === 2 ? true : false
                  }
                />
              </ul>
            </div>
          </div>
          <HeaderSearch className='d-inline-block d-sm-none search-sm w-100' />
        </div>
        <div className='sub-header-group'>
          <div className='sub-header sub-header-checkout'>
            <SideMenu data={categories} />
            {/* <HeaderNavigation data={menu} /> */}
          </div>
        </div>
      </header>
    </>
  );
};

export default memo(CheckoutHeader);
